<template>
  <div>
    <div class="row">
      <div>
        <api-header id="webhooks" tag="h2">{{ $t('documentation.api.webhooks.title') }}</api-header>
        <i18n-t keypath="documentation.api.webhooks.description.summary" tag="p" scope="global" />
        <i18n-t keypath="documentation.api.webhooks.description.learnMore.message" tag="p" scope="global">
          <template #link>
            <link-wrapper href="/getting-started/concepts/webhooks"
              >{{ $t('documentation.api.webhooks.description.learnMore.linkText') }}
            </link-wrapper>
          </template>
        </i18n-t>
        <i18n-t keypath="documentation.api.webhooks.description.responses" tag="p" scope="global">
          <template #code200>
            <code>200</code>
          </template>
          <template #code204>
            <code>204</code>
          </template>
        </i18n-t>
        <available-operations :operations="document.webhooks" />
      </div>
    </div>
    <api-callback-section
      v-for="webhook in document.webhooks"
      :id="webhook.id"
      :key="webhook.id"
      :operation="webhook"
      type="webhook"
    />
  </div>
</template>
<script setup lang="ts">
import { ApiDoc } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import { PropType } from 'vue';
import ApiCallbackSection from '@/components/api/content/common/ApiCallbackSection.vue';
import ApiHeader from '@/components/api/content/common/ApiHeader.vue';
import { LinkWrapper } from '@/components/markdown/widgets';
import AvailableOperations from '@/components/api/content/common/AvailableOperations.vue';

defineProps({
  document: { type: Object as PropType<ApiDoc>, required: true },
});
</script>
